import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ITablePagination, Notification } from 'src/app/models/domain';
import { NotificationDataService } from 'src/app/services';
import { handleError } from 'src/app/state/akita-error-helper';
import { ErrorState } from 'src/app/state/error-state';
import { IPage } from 'src/app/state/paged-collection';

@Injectable({ providedIn: 'root' })
export class MaintenanceManagementSystemHistoryService {
  private readonly state = new ErrorState();

  public readonly error$ = this.state.error$;

  public constructor(private readonly notificationsService: NotificationDataService) {}

  public loadHistoryPage(
    { perPage, page }: ITablePagination,
    equipmentNumber?: string
  ): Observable<IPage<Notification>> {
    // Starting a load clears the previous error, which CustomEntityStore.setLoading(true)
    // used to do. Without it a transient failure sticks: the template renders the error
    // instead of the table, so a later success would never be seen.
    this.state.setError(undefined);

    if (!equipmentNumber) {
      return of({ currentPage: page, data: [], lastPage: 1, perPage, total: 0 });
    }

    return this.notificationsService.loadNotificationPage(equipmentNumber, { perPage, page }).pipe(
      map(({ data, total }): IPage<Notification> => ({
        currentPage: page,
        data,
        lastPage: Math.ceil(total / perPage),
        perPage,
        total,
      })),
      catchError((error) => {
        handleError(this.state, error);

        // EMPTY, not NEVER: PagedCollection's finalize() has to run to clear the
        // spinner. Akita got this implicitly, because its setError also called
        // set([]), which cleared loading.
        return EMPTY;
      })
    );
  }
}
